<template>
  <div style="background: white">
    <van-cell v-if="!feedbackPkId" title="反馈类型:" is-link :value="getTypeDesc" value-class="value-class" title-class="title-class"
              @click="showPicker = true"/>
    <van-divider :style="{ borderColor: '#dcdcdc', margin: '0 0', padding: '0 0.2rem' }"/>
    <div class="input-container">
      <van-field
        v-model="message"
        rows="4"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入你的意见反馈"
        show-word-limit
        style="background: #F8F4F5; margin: 0 0.2rem"
      />
    </div>
    <van-divider :style="{ borderColor: '#dcdcdc', margin: '0 0', padding: '0 0.2rem' }"/>
    <div class="uploader-container">
      <van-uploader :max-count="6" @click.native="onFileClick" :disabled="disabled" :after-read="afterRead" :before-delete="beforeDelete" v-model="remarkImageUrl" multiple/>
    </div>
    <div class="button1" @click="submitButtonAction">提交</div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        :default-index="selectColumns"
        :style="{ height: '50%' }"
        @cancel="showPicker = false"
        @confirm="onPickerConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Field, Cell, Uploader, Divider, Popup, Picker, Image } from 'vant';
import { getDictInfo, submitAdvice, uploadImage, getUserBaseInfo, replyFeedBack } from '../../common/api';
import { photoCompress } from '../../common/utils';
let toast = null;
export default {
  name: 'feedback',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Uploader.name]: Uploader,
    [Divider.name]: Divider,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Image.name]: Image,
  },
  data () {
    return {
      disabled: false,
      message: '',
      fileList: [],
      remarkImages: [],
      remarkImageUrl: [],
      typeList: [],
      columns: [],
      showPicker: false,
      selectColumns: 0,
      userObject: {},
      feedbackPkId: ""
    };
  },
  mounted () {
    this.feedbackPkId = this.$route.query.feedbackPkId || '';
    if(this.feedbackPkId == ''){
      this.getTypeList();
    }
    
    this.getUser();
  },
  computed: {
    getTypeDesc () {
      if (this.columns.length > 0) {
        return this.columns[this.selectColumns];
      }
      return '';
    }
  },
  methods: {
    getUser(){
      getUserBaseInfo(null)
          .then(response => {
            if (
              response.status === this.$config.ajaxStatus &&
              response.data.length > 0
            ) {
              this.userObject = response.data[0];
            }
          })
    },
    onFileClick () {
      setTimeout(()=>{
        this.disabled = false;
      },300);
      setTimeout(()=>{
        this.disabled = true;
      },0);
    },
    onPickerConfirm (value) {
      this.showPicker = false;
      this.selectColumns = this.columns.indexOf(value);
    },
    getTypeList () {
      getDictInfo({
        typeId: 1062
      }, true).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          this.typeList = data.data;
          this.columns = data.data.map(item => {
            return item.itemValue;
          });
        } else {
          throw new Error();
        }

      }).catch((error) => {
        console.log(error);
      });
    },
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      if(file.file.type == 'image/gif'){
        this.$toast('不能上传gif类型图片');
        this.remarkImageUrl.splice(this.remarkImageUrl.length - 1, 1);
        return;
      }else{
        if (file.length > 1) {
          file.forEach(item => {
            this.fileList.push(item.file);
          });
        } else {
          this.fileList.push(file.file);
        }
      }
    },

    beforeDelete (file) {
      // console.log('before delete');
      // console.log(file);
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].name === file.file.name) {
          this.fileList.splice(i, 1);
          break;
        }
      }
      return true;
    },

    submitButtonAction () {
      if(this.$common.isEmpty(this.message)){
        this.$toast('反馈内容不能为空');
        return
      }
      toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });
      this.uploadImages()
        .then((response) => {
          this.remarkImages = [];
          response.forEach(item => {
            let data = item.data;
            if (data.length > 0) {
              let image = data[0];
              this.remarkImages.push(image);
            }
          });
          if(this.feedbackPkId == ''){
            return submitAdvice({
            content: this.message,
            contactPhone: this.userObject.phoneNo,
            feedBackType: this.typeList[this.selectColumns].itemKey,
            picturesParamList: this.remarkImages
          });
          }else{
            return replyFeedBack({
              content: this.message,
              feedBackPkId: this.feedbackPkId,
              picturesParamList: this.remarkImages
            });
          }
          
        }).then(() => {
        toast.clear();
        this.$dialog.alert({
          title: '提交成功',
          confirmButtonText: '关闭',
          confirmButtonColor: '#999999',
          closeOnPopstate: true
        }).then(() => {
          this.$router.go(-1);
        })
      }).catch(error => {
        console.log(error);
        toast.clear();
        if (error.response && error.response.status === 413) {
          this.$toast('提交失败，图片太大了');
        }
        this.$toast('提交失败！');
      });
    },

    uploadImages () {
      let that = this;
      let uploadImageTaskArray = [];
      that.remarkImages = [];
      // console.log(that.remarkImages);
      let uploadSingleImage = (file) => {
        if ((file.size / (1024 * 1024)) > 3) {
          return new Promise((resolve, reject) => {
            photoCompress(file, {
              quality: ((1024 * 1024*3.0)/file.size)   //限制大小最大为3M
            }, function(fileobj) {
              const fileData = new FormData();
              fileData.append('file', fileobj, 'file_' + Date.parse(new Date()) + '.jpg');
              uploadImage(fileData).then((response) => {
                resolve(response);
              }).catch((error) => {
                reject(error);
              });
            });
          });
        } else {
          const fileData = new FormData();
          fileData.append('file', file);
          return new Promise((resolve, reject) => {
            uploadImage(fileData).then((response) => {
              resolve(response);
            }).catch((error) => {
              reject(error);
            });
          });
        }
      };

      this.fileList.forEach(item => {
        uploadImageTaskArray.push(uploadSingleImage(item));
      });
      return Promise.all(uploadImageTaskArray);
    },
  }
};
</script>

<style lang="less" scoped>
.value-class {
  font-size: 0.32rem;
  color: #333333;
  text-align: left;
  padding-left: 0.2rem;
}

.title-class {
  font-size: 0.32rem;
  color: #666666;
  flex: 0 1 auto
}

.input-container {
  padding: 0.2rem 0;
  display: flex;
}

.uploader-container {
  padding: 0.2rem;
  display: flex;
}
</style>
